import React from "react";
import Svg, { Path, SvgProps } from "react-native-svg";

const WarningIcon = (props: SvgProps) => {
  return (
    <Svg fill="none" width="34" height="30" viewBox="0 0 35 35" {...props}>
      <Path
        d="M17 1.003c.899 0 1.612.56 2.081 1.294l.09.15.005.006 12.908 22.753c.493.855.602 1.864.027 2.691-.545.784-1.505 1.106-2.489 1.106H4.378c-.984 0-1.944-.322-2.49-1.106-.574-.827-.465-1.836.028-2.691L14.824 2.453l.004-.006c.465-.806 1.213-1.444 2.172-1.444Z"
        fill="#FB0"
        stroke="#171B1F"
        strokeWidth="2"
      />
      <path
        d="m14.989 11.454 1.356 8.96c.145.873 1.26.873 1.405 0l1.307-8.96c.242-3.488-4.31-3.488-4.068 0ZM17.023 26.082a2.034 2.034 0 1 0 0-4.069 2.034 2.034 0 0 0 0 4.069Z"
        fill="#171B1F"
      />
    </Svg>
  );
};

export default WarningIcon;
